/**
 * Een opnamebestand naar de backend sturen met zichtbare voortgang.
 *
 * `fetch` kan geen voortgang melden en een afgebroken upload komt daar binnen als
 * het nietszeggende "Failed to fetch" (Joris, 10 sep 2026: upload van een lange
 * opname klapte eruit zonder dat er iets in de logs stond). Daarom XHR: die geeft
 * percentages én laat het verschil zien tussen "de server zei nee" en "de
 * verbinding haalde het niet".
 */

/** Leesbare melding bij een mislukte upload. */
export function uploadFoutTekst(status, antwoord) {
  if (status === 0) {
    return 'De verbinding werd onderbroken voordat het bestand binnen was. '
      + 'Probeer het opnieuw op een vaste verbinding, of gebruik de recorder-app voor grote bestanden.';
  }
  if (status === 401) return 'Je recorder-sleutel is verlopen — maak een nieuwe aan via Recorder Setup.';
  if (status === 413) return 'Het bestand is te groot voor deze weg — gebruik de recorder-app (Bestand uploaden…).';
  let melding = '';
  try { melding = JSON.parse(antwoord || '{}')?.error || ''; } catch { melding = ''; }
  return melding || `De server gaf HTTP ${status} terug.`;
}

/**
 * @param url        endpoint
 * @param velden     { veldnaam: waarde } naast het bestand
 * @param sleutel    recorder-sleutel voor de X-Recorder-Key header
 * @param onVoortgang callback met een percentage (0-100)
 */
export function stuurOpname(opties) {
  return stuurBestand({ ...opties, veld: 'audio' });
}

/**
 * Zelfde weg voor elk bestand: `veld` is de naam die de server verwacht
 * ('audio' bij de recorder, 'file' bij een inspiratievideo).
 */
export function stuurBestand({ url, bestand, veld = 'file', velden = {}, sleutel, headers = {}, onVoortgang }) {
  return new Promise((resolve, reject) => {
    const vorm = new FormData();
    vorm.append(veld, bestand, bestand.name);
    Object.entries(velden).forEach(([k, v]) => vorm.append(k, v));

    const xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    if (sleutel) xhr.setRequestHeader('X-Recorder-Key', sleutel);
    Object.entries(headers).forEach(([k, v]) => v && xhr.setRequestHeader(k, v));
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onVoortgang) onVoortgang(Math.round((e.loaded / e.total) * 100));
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        let uit = {};
        try { uit = JSON.parse(xhr.responseText || '{}'); } catch { uit = {}; }
        resolve(uit);
      } else {
        reject(new Error(uploadFoutTekst(xhr.status, xhr.responseText)));
      }
    };
    xhr.onerror = () => reject(new Error(uploadFoutTekst(0)));
    xhr.ontimeout = () => reject(new Error(uploadFoutTekst(0)));
    xhr.send(vorm);
  });
}
